var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "import-config": _vm.importConfig,
          "export-config": _vm.exportConfig,
          "cell-click": _vm.chooseRow,
          cellDbClick: _vm.updateRow,
        },
        on: { "toolbar-addData": _vm.addRow, "toolbar-delData": _vm.delRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "vxe-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "ACTIVATION",
                          expression: "'ACTIVATION'",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.changeStatus(1)
                        },
                      },
                    },
                    [_vm._v("激活")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "HANGUP",
                          expression: "'HANGUP'",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.changeStatus(0)
                        },
                      },
                    },
                    [_vm._v("挂起")]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }